import { useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import { styled, Theme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Scrollbar from '../../control/Scrollbar'

type ContentWelcomeProps = {
    onClickAccept: () => void
    data: TermsAndConditionsType
}
const ContentWelcome = (props: ContentWelcomeProps) => {
    const { data } = props
    const classes = useStyles()
    const [disabledButton, setDisabledButton] = useState(true)

    useEffect(() => {
        if (data && (data?.body?.length || 0) < 500) {
            setDisabledButton(false)
        }
    }, [data])

    const handleScroll = (event: any) => {
        const floor = (num: number) => Math.floor(num)
        const topDevHeight = floor(event.target.scrollHeight) - floor(event.target.scrollTop)
        const clientHeight = floor(event.target.clientHeight)
        const bottom = Math.abs(topDevHeight - clientHeight) < 20

        if (bottom) {
            setDisabledButton(false)
        }
    }

    return (
        <div className={classes.root}>
            <div className={classes.elementLeft}>
            <img
                    src={`${process.env.REACT_APP_IMAGE_PATH}/assets/image/logo_main.png`}
                    className={classes.imgLogoLeftDesktop}
                />
                <img
                    src={`${process.env.REACT_APP_IMAGE_PATH}/assets/image/logo_system_name.png`}
                    className={classes.imgLogoLeft}
                />
                {/* <img
                    src={`${process.env.REACT_APP_FOLDER_APPLICATION}/assets/image/logo_white.png`}
                    className={classes.imgLogoLeft}
                /> */}
            </div>
            <div className={classes.elementRight} style={{ padding: '0px' }}>
                <Stack spacing={1}>
                    <StyledDialogWelcomeRightTitle>
                        <Typography variant="h5" className={classes.textTitle}>
                            {data?.title}
                        </Typography>
                    </StyledDialogWelcomeRightTitle>
                    <StyledDialogWelcomeRightContent>
                        <StyledDialogWelcomeBlock>
                            <StyledDialogWelcomeBlockContent>
                                <Scrollbar
                                    scrollbarTrackBorderRadius={10}
                                    scrollbarThumbBorderRadius={10}
                                    onScroll={handleScroll}
                                >
                                    <StyledDialogWelcomeTextContent
                                        dangerouslySetInnerHTML={{ __html: data?.body || '' }}
                                    />
                                </Scrollbar>
                            </StyledDialogWelcomeBlockContent>
                        </StyledDialogWelcomeBlock>
                    </StyledDialogWelcomeRightContent>
                    <StyledDialogWelcomeButtonSubmit>
                        <Button
                            onClick={props.onClickAccept}
                            disabled={disabledButton}
                            className={disabledButton ? classes.buttonDisable : classes.buttonEnable}
                        >
                            {'ตกลง และยอมรับเงื่อนไข'}
                        </Button>
                    </StyledDialogWelcomeButtonSubmit>
                    <StyledDialogWelcomeRemark>
                        <StyledTypoRemark>
                            {
                                '** กรุณาอ่านข้อกำหนด และเงื่อนไขการให้บริการให้ครบ โดยเลื่อนเนื้อหาลงล่างสุด เพื่อยืนยันการตกลง และยอมรับเงื่อนไข'
                            }
                        </StyledTypoRemark>
                    </StyledDialogWelcomeRemark>
                </Stack>
            </div>
        </div>
    )
}

export default ContentWelcome

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        //background: 'linear-gradient(180deg, #2780F9 50.05%, #0A347A 99.19%)',
        // backgroundColor: theme.palette.primary.main,
        backgroundImage: theme.palette.getContrastText('gradient'),
        [theme.breakpoints.down('md')]: {
            display: 'block',
            // backgroundColor: 'transparent',
            // backgroundImage: `url(${process.env.REACT_APP_FOLDER_APPLICATION}/assets/image/bg_blue.jpg)`,
            // backgroundRepeat: 'no-repeat',
            // backgroundSize: 'cover',
        },
    },
    elementLeft: {
        width: 400,
        backgroundImage: `url(${process.env.REACT_APP_IMAGE_PATH}/assets/image/bg_login_no_logo.png)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        borderRadius: '5px 0px 0px 5px',
        //display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign:'center',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            textAlign: 'center',
            display: 'block',
            paddingTop: theme.spacing(1),
            backgroundImage: 'none',
        },
    },
    imgLogoLeftDesktop: {
        width:260,
        position:'relative',
        top:60,
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    imgLogoLeft: {
        marginTop: 0,
        display: 'none',
        width:200,
        [theme.breakpoints.down('md')]: {
            marginTop: 10,
            display: 'inline',
        },
        [theme.breakpoints.down('sm')]: {
            width:120,
            marginTop: 6,
            display: 'inline',
        },
    },
    elementRight: {
        width: 540,
        display: 'flex',
        //background: 'linear-gradient(180deg, #2780F9 50.05%, #0A347A 99.19%)',
        backgroundImage: theme.palette.getContrastText('gradient'),
        // backgroundImage: `url(${process.env.REACT_APP_FOLDER_APPLICATION}/assets/image/bg_blue.jpg)`,
        // backgroundRepeat: 'no-repeat',
        // backgroundSize: 'cover',
        borderTopLeftRadius: '10px',
        borderBottomLeftRadius: '10px',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            display: 'block',
            backgroundImage: 'none',
        },
    },
    textTitle: {
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px !important',
        },
    },
    buttonEnable: {
        color: `${theme.palette.text.secondary} !important`,
        backgroundColor: `${theme.palette.primary.main} !important`,
        width: '200px !important',
    },
    buttonDisable: {
        color: `${theme.palette.secondary.dark} !important`,
        backgroundColor: `${theme.palette.text.secondary} !important`,
        width: '200px !important',
    },
}))

const StyledDialogWelcomeRightTitle = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 0',
    color: theme.palette.text.secondary,
    height: '10%',
    [theme.breakpoints.down('sm')]: {
        paddingTop: '10px',
        paddingRight: '0px',
        paddingBottom: '0px',
        paddingLeft: '0px',
    },
}))

const StyledDialogWelcomeRightContent = styled('div')(({ theme }) => ({
    height: '400px',
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(0),
    },
}))

const StyledDialogWelcomeBlock = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.text.secondary,
    borderRadius: '10px',
    height: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0),
    },
}))

const StyledDialogWelcomeBlockContent = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.text.secondary,
    color: theme.palette.text.primary,
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
        borderRadius: '10px',
    },
}))

const StyledDialogWelcomeTextContent = styled('div')(({ theme }) => ({
    padding: theme.spacing(2),
}))

const StyledDialogWelcomeButtonSubmit = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 0px 10px 0px',
    height: '10%',
    [theme.breakpoints.down('sm')]: {
        paddingTop: '0px',
        paddingBottom: '10px',
    },
}))

const StyledDialogWelcomeRemark = styled('div')(({ theme }) => ({
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
    },
    [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
}))

const StyledTypoRemark = styled(Typography)(({ theme }) => ({
    fontSize: '12px',
    color: theme.palette.text.secondary,
}))
